import { z } from "zod"
import {
  CampaignStatusEnum,
  CampaignTriggerTypeEnum,
  channelResponseSchema,
} from "../../campaigns/commonTypes"
import { OrganizationTypeEnum } from "../../companies/dtos"

export const CampaignHealthResultResponseDataSchema = z.object({
  campaignId: z.string(),
  name: z.string().nullable(),
  companyName: z.string(),
  companyLogo: z.string().nullable(),
  organizationName: z.string(),
  organizationType: z.enum(OrganizationTypeEnum),
  lastLogin: z.string().nullable(),
  hasBriefing: z.boolean(),
  status: z.enum(CampaignStatusEnum),
  trigger: z.enum(CampaignTriggerTypeEnum).nullable(),
  channel: channelResponseSchema,
  defaultLanguage: z.string().nullable(),
  ticketEscalation: z.boolean(),
  bizOpEscalation: z.boolean(),
  reviews: z.literal("Review").nullable(),
  avgAssistant: z.number(),
  conversations30d: z.number(),
  conversations7d: z.number(),
  conversations3d: z.number(),
  engagementRate30d: z.number(),
  engagementRate7d: z.number(),
  engagementRate3d: z.number(),
  avgAssistantMessagesPerConversationInbound: z.number(),
  avgAssistantMessagesPerConversationOutbound: z.number(),
  filterOut7d: z.number(),
  whatsappTemplatesEs: z.number(),
  whatsappTemplatesEn: z.number(),
  whatsappTemplatesCat: z.number(),
  whatsappTemplatesFr: z.number(),
  whatsappOpeningMessagesEs: z.number(),
  whatsappOpeningMessagesEn: z.number(),
})

export const CampaignHealthResultsResponseDataSchema = z.array(
  CampaignHealthResultResponseDataSchema,
)
